import { styled } from "@mui/material";
import React from "react";

interface Data {
    name: string;
}

const ViewRoleContent: React.FC<Data> = ({ name }) => {
    return (
        <StyledContainer>
            <StyledWrapper>
                <StyledText>Status</StyledText>
                <Active>Active</Active>
            </StyledWrapper>
            <StyledWrapper>
                <StyledText>Name</StyledText>
                <StyledDate>{name}</StyledDate>
            </StyledWrapper>
        </StyledContainer>
    )
}

export default ViewRoleContent;

const StyledContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding-block-start: 3rem;
    padding-block-end: 5rem;
    padding-inline: 2rem;
`

const StyledWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
`

const StyledText = styled('span')`
    font-size: 24px;
    font-weight: 400;
    color: #4E5A62;
`

const Active = styled('span')`
    font-size: 16px;
    font-weight: 500;
    background-color: #E0FAEE;
    border-radius: 0.4rem;
    padding-inline: 2rem;
    padding-block: 0.5rem;
    color: #11643C;
`

const StyledDate = styled(StyledText)`
    color: #020D08;
    font-weight: 500;
`